/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIEditor } from './APIEditor';
import {
    APIEditorFromJSON,
    APIEditorFromJSONTyped,
    APIEditorToJSON,
} from './APIEditor';
import type { APIRequestArticle } from './APIRequestArticle';
import {
    APIRequestArticleFromJSON,
    APIRequestArticleFromJSONTyped,
    APIRequestArticleToJSON,
} from './APIRequestArticle';
import type { APIRequestContact } from './APIRequestContact';
import {
    APIRequestContactFromJSON,
    APIRequestContactFromJSONTyped,
    APIRequestContactToJSON,
} from './APIRequestContact';

/**
 * 
 * @export
 * @interface APIRequestSearchResult
 */
export interface APIRequestSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIRequestSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    certificate?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    quantities?: string;
    /**
     * 
     * @type {number}
     * @memberof APIRequestSearchResult
     */
    status?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    statusDisplay?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIRequestSearchResult
     */
    priority?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIRequestSearchResult
     */
    isTemp?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestSearchResult
     */
    wishDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestSearchResult
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestSearchResult
     */
    lastModifiedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIRequestSearchResult
     */
    articleCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRequestSearchResult
     */
    articleNumbers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRequestSearchResult
     */
    articleNames?: Array<string>;
    /**
     * 
     * @type {Array<APIRequestArticle>}
     * @memberof APIRequestSearchResult
     */
    articles?: Array<APIRequestArticle>;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    contactFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    contactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    contactPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    contactMobile?: string;
    /**
     * 
     * @type {APIRequestContact}
     * @memberof APIRequestSearchResult
     */
    contact?: APIRequestContact | null;
    /**
     * 
     * @type {number}
     * @memberof APIRequestSearchResult
     */
    editorCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRequestSearchResult
     */
    editorNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRequestSearchResult
     */
    editorIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRequestSearchResult
     */
    editorEmails?: Array<string>;
    /**
     * 
     * @type {Array<APIEditor>}
     * @memberof APIRequestSearchResult
     */
    editors?: Array<APIEditor>;
    /**
     * 
     * @type {string}
     * @memberof APIRequestSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APIRequestSearchResult interface.
 */
export function instanceOfAPIRequestSearchResult(value: object): value is APIRequestSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIRequestSearchResultFromJSON(json: any): APIRequestSearchResult {
    return APIRequestSearchResultFromJSONTyped(json, false);
}

export function APIRequestSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'certificate': json['certificate'] == null ? undefined : json['certificate'],
        'country': json['country'] == null ? undefined : json['country'],
        'description': json['description'] == null ? undefined : json['description'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'quantities': json['quantities'] == null ? undefined : json['quantities'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusDisplay': json['status_display'] == null ? undefined : json['status_display'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'isTemp': json['is_temp'] == null ? undefined : json['is_temp'],
        'wishDate': json['wish_date'] == null ? undefined : (new Date(json['wish_date'])),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'lastModifiedAt': json['last_modified_at'] == null ? undefined : (new Date(json['last_modified_at'])),
        'articleCount': json['article_count'] == null ? undefined : json['article_count'],
        'articleNumbers': json['article_numbers'] == null ? undefined : json['article_numbers'],
        'articleNames': json['article_names'] == null ? undefined : json['article_names'],
        'articles': json['articles'] == null ? undefined : ((json['articles'] as Array<any>).map(APIRequestArticleFromJSON)),
        'contactFullName': json['contact_full_name'] == null ? undefined : json['contact_full_name'],
        'contactEmail': json['contact_email'] == null ? undefined : json['contact_email'],
        'contactPhone': json['contact_phone'] == null ? undefined : json['contact_phone'],
        'contactMobile': json['contact_mobile'] == null ? undefined : json['contact_mobile'],
        'contact': json['contact'] == null ? undefined : APIRequestContactFromJSON(json['contact']),
        'editorCount': json['editor_count'] == null ? undefined : json['editor_count'],
        'editorNames': json['editor_names'] == null ? undefined : json['editor_names'],
        'editorIds': json['editor_ids'] == null ? undefined : json['editor_ids'],
        'editorEmails': json['editor_emails'] == null ? undefined : json['editor_emails'],
        'editors': json['editors'] == null ? undefined : ((json['editors'] as Array<any>).map(APIEditorFromJSON)),
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APIRequestSearchResultToJSON(value?: APIRequestSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'certificate': value['certificate'],
        'country': value['country'],
        'description': value['description'],
        'remarks': value['remarks'],
        'quantities': value['quantities'],
        'status': value['status'],
        'status_display': value['statusDisplay'],
        'priority': value['priority'],
        'is_temp': value['isTemp'],
        'wish_date': value['wishDate'] == null ? undefined : ((value['wishDate'] as any).toISOString().substring(0,10)),
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'last_modified_at': value['lastModifiedAt'] == null ? undefined : ((value['lastModifiedAt'] as any).toISOString()),
        'article_count': value['articleCount'],
        'article_numbers': value['articleNumbers'],
        'article_names': value['articleNames'],
        'articles': value['articles'] == null ? undefined : ((value['articles'] as Array<any>).map(APIRequestArticleToJSON)),
        'contact_full_name': value['contactFullName'],
        'contact_email': value['contactEmail'],
        'contact_phone': value['contactPhone'],
        'contact_mobile': value['contactMobile'],
        'contact': APIRequestContactToJSON(value['contact']),
        'editor_count': value['editorCount'],
        'editor_names': value['editorNames'],
        'editor_ids': value['editorIds'],
        'editor_emails': value['editorEmails'],
        'editors': value['editors'] == null ? undefined : ((value['editors'] as Array<any>).map(APIEditorToJSON)),
        'root_account_id': value['rootAccountId'],
    };
}

